export const PHONE_MASK = '(000) 000-0000';

// Progressive (XXX) XXX-XXXX formatting. Deliberately does NOT strip a leading
// country code — a shifted number renders visibly wrong and fails validation
// with the country-code message, matching the design.
export const maskPhone = (raw) => {
  const d = String(raw ?? '')
    .replace(/\D/g, '')
    .slice(0, 10);
  if (!d.length) return '';
  if (d.length < 4) return `(${d}`;
  if (d.length < 7) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
};

// NANP: 10 digits, area code can't start with 0 or 1
export const isValidPhone = (raw) => {
  const d = String(raw ?? '').replace(/\D/g, '');
  return d.length === 10 && !/^[01]/.test(d);
};

// Unfilled remainder of the mask, for the ghost hint after the typed value.
export const phoneGhost = (value) => {
  const v = value || '';
  return v.length > 0 && v.length < PHONE_MASK.length
    ? PHONE_MASK.slice(v.length)
    : '';
};
